import React from "react";
import { FixLater } from "types";
import { Button } from "components/Buttons/Button";

const AuthSubmitButton = ({ children, isDisabled, className, onClick }: FixLater) => {
  return (
    <Button size="large" type="submit" disabled={isDisabled} className={className} onClick={onClick}>
      {children}
    </Button>
  );
};

export default AuthSubmitButton;
